import { Pagination, paginationToParams } from '../interfaces/Pagination';
import { MyOrder, myOrderFromResponse } from '../interfaces/Order/MyOrder';
import api, { apiPrefix } from './Api';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import { Order, orderFromResponse } from '../interfaces/Order/Order';

export const getMyOrders = async (
  pagination: Pagination,
): Promise<PaginatedResponse<MyOrder>> => {
  const response = await api.get(`${apiPrefix}/my-orders`, {
    params: paginationToParams(pagination),
  });

  return {
    data: (response.data?.data ?? []).map(myOrderFromResponse),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const getOrderByID = async (id: number): Promise<Order> => {
  const response = await api.get(`${apiPrefix}/findOrderById/${id}`);

  return orderFromResponse(response.data);
};
